export default __webpack_public_path__ + "static/media/water10.f4c106a2.png";